<script lang="ts">
  import emailjs from "@emailjs/browser";
  import { Whatsapp, Instagram, Facebook,HouseCheck } from "svelte-bootstrap-icons";

  let currentService: string = "inmuebles";
  let currentQuestion: string = "necesitar";

  let isFormSuccessVisible: boolean = false;
  const TEMPLATE_ID: string = "template_2v1bi4f";
  const SERVICE_ID: string = "service_ucwp2hb";
  const PUBLIC_LLAVE: string = "_AlE9nM7WXPYaoUS1";

  const handleSelectService = (selectedService: string) => {
    currentService = selectedService;
  };
  const handleSelectQuestion = (selectedQuestion: string) => {
    if (selectedQuestion === currentQuestion) {
      currentQuestion = "";
      return;
    }
    currentQuestion = selectedQuestion;
  };

  function sendEmail(e) {
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_LLAVE).then(
      (result) => {
        console.log("SUCCESS!", result.text);
        isFormSuccessVisible = true;

        setTimeout(function () {
          isFormSuccessVisible = false;
        }, 4000);
      },
      (error) => {
        console.log("FAILED...", error.text);
      }
    );
  }
</script>

<svelte:head>
  <title>CONMETODO</title>
  <html lang="es" />
</svelte:head>

<header class="navbar bg-base-100 z md:p-2">
  <div class="navbar-start">
    <div class="dropdown">
      <div tabindex="0" class="btn btn-ghost lg:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h8m-8 6h16"
          /></svg
        >
      </div>
      <ul
        tabindex="0"
        class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
      >
        <li><a href="#quienes-somos">¿Quiénes Somos?</a></li>
        <li>
          <a on:click={() => handleSelectService("inmuebles")} href="#servicios"
            >Valuación Inmuebles</a
          >
        </li>
        <li>
          <a on:click={() => handleSelectService("muebles")} href="#servicios"
            >Valuación Muebles</a
          >
        </li>
        <li>
          <a
            on:click={() => handleSelectService("intangibles")}
            href="#servicios">Valuación Intangibles</a
          >
        </li>
        <li><a href="#certificaciones">Certificaciones</a></li>
        <li><a href="#preguntas">Preguntas Frecuentes</a></li>
      </ul>
    </div>
    <a class="btn btn-ghost border-none p-0" href="/"
      ><img class="w-sm h-full rounded" src="images/logo.png" alt="Logo" /></a
    >
  </div>
  <div class="navbar-center hidden lg:flex">
    <ul class="menu menu-horizontal p-0">
      <li><a href="#quienes-somos"> ¿Quiénes Somos?</a></li>
      <li tabindex="0">
        <a href="#servicios">
          Valuaciones
          <svg
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            ><path
              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
            /></svg
          >
        </a>
        <ul class="dropdown-content p-2 shadow bg-base-100 rounded-box w-44">
          <li>
            <a
              on:click={() => handleSelectService("inmuebles")}
              href="#servicios">Inmuebles</a
            >
          </li>
          <li>
            <a on:click={() => handleSelectService("muebles")} href="#servicios"
              >Muebles</a
            >
          </li>
          <li>
            <a
              on:click={() => handleSelectService("intangibles")}
              href="#servicios">Intangibles</a
            >
          </li>
        </ul>
      </li>
      <li><a href="#certificaciones">Certificaciones</a></li>
      <li><a href="#preguntas">Preguntas Frecuentes</a></li>
    </ul>
  </div>
  <div class="hidden md:flex md:navbar-end">
    <a class="btn" href="#contactenos">Contáctenos</a>
  </div>
</header>
<main>
  <!-- Hero -->
  <div
    class="hero min-h-screen"
    style="background-image: url(images/background-eje.jpg);"
  >
    <div class="hero-overlay bg-opacity-60" />
    <div class="hero-content text-center text-neutral-content">
      <div class="max-w-sm md:max-w-md">
        <h1 class="mb-5 text-5xl font-bold">CONMETODO</h1>
        <p class="mb-5">
          Expertos en la realización de tasaciones de inmuebles,
          infraestructuras especiales de inmuebles, maquinaria, equipos, bienes
          y valoraciones de empresas.
        </p>
        <a href="#quienes-somos" class="btn btn-primary">Conoce Más</a>
      </div>
    </div>
  </div>
  <section class="w-full p-4 md:py-8 md:px-12" id="quienes-somos">
    <div class="max-w-sm md:max-w-6xl m-auto">
      <h2 class="text-3xl font-bold text-center text-primary">
        ¿Quiénes Somos?
      </h2>
      <p class="my-5 text-center">
        Realizamos valuaciones de activos tangibles e Intangibles bajo las
        Normas Internacionales de Información Financiera N.I.I.F. y las Normas
        IVSC de Valuación, además de obtener los valores razonables de los
        activos, los valores remanentes, las vidas útiles y remanentes de los
        activos, teniendo en cuenta las políticas contables de la empresa.
        Nuestra experiencia, formación y profesionalismo por más de 26 años nos
        permite posicionarnos como una empresa de gran competitividad y
        relevancia en el sector.
      </p>
    </div>

    <h3 class="max-wd-md text-2xl font-semibold text-center text-primary">
      Nuestros Clientes
    </h3>
    <div class="h-52 p-4">
      <div
        class="carousel carousel-center w-fit m-auto max-w-full p-4 space-x-4 bg-neutral rounded-box"
      >
        <div class="carousel-item">
          <img
            src="images/image3.png"
            alt="logo "
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/inca.jpg"
            alt="logo inca"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/codis.png"
            alt="logo codis"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/u-de-cundinamarca.png"
            alt="logo u-de-cundinamarca"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/utp.png"
            alt="logo utp"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/zona-segura.jpg"
            alt="logo zona segura"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/integra.png"
            alt="logo integra"
            class="rounded-box grayscale"
          />
        </div>
        <div class="carousel-item">
          <img
            src="images/tractec.png"
            alt="logo tractec"
            class="rounded-box grayscale"
          />
        </div>
      </div>
    </div>
  </section>
  <section id="servicios" class="w-full p-4 bg-neutral md:py-8 md:px-12">
    <h2 class="text-3xl mb-4 font-bold text-center text-primary">
      Nuestros Servicios
    </h2>
    <div class="max-w-sm md:max-w-6xl m-auto">
      <div class="flex flex-col md:flex-row w-full gap-2 ">
        <div
          class="grid p-4 flex-grow card bg-base-300 rounded-box place-items-center flex-wrap"
        >
          <h3
            class="max-wd-md text-2xl font-bold text-center text-primary mb-4"
          >
            Valuaciones
          </h3>

          <p class="text-center max-w-full">
            Contamos con un grupo profesional de valuadores debidamente
            acreditados e inscritos ante el Registro Abierto de Avaluadores, y
            la Sociedad Colombiana de Valuadores, quienes conforman una red que
            nos autoriza a realizar una cobertura a nivel nacional.
          </p>
        </div>
        <div class="divider divider-horizontal" />
        <div
          class="grid p-4 flex-grow card bg-base-300 rounded-box place-items-center flex-wrap"
        >
          <h3
            class="max-wd-md text-2xl font-bold text-center text-primary mb-4"
          >
            Inventarios
          </h3>
          <p class="text-center">
            Realizamos inventarios técnicos de sus activos muebles por medio de
            barridos o de conteo.Nuestros clientes reciben conceptos técnicos y
            comerciales que nos permite lograr los mejores resultados, basados
            en modernas técnicas de la práctica valuatoria.
          </p>
        </div>
      </div>
      <div class="tabs mx-4 mt-8">
        <button
          class={`tab tab-lifted ${
            currentService === "inmuebles" ? "tab-active" : ""
          }`}
          on:click={() => handleSelectService("inmuebles")}>Inmuebles</button
        >
        <button
          class={`tab tab-lifted ${
            currentService === "muebles" ? "tab-active" : ""
          }`}
          on:click={() => handleSelectService("muebles")}>Muebles</button
        >
        <button
          class={`tab tab-lifted ${
            currentService === "intangibles" ? "tab-active" : ""
          }`}
          on:click={() => handleSelectService("intangibles")}
          >Intangibles</button
        >
      </div>

      <div
        class="grid p-4 flex-grow card bg-base-100 rounded-box flex-wrap gap-4"
      >
        <!-- This is the section for Inmuebles -->
        {#if currentService === "inmuebles"}
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Inmuebles Urbanos:
            </h2>
            <p>
              Clubes, hospitales, clínicas, bodegas, casas, apartamentos,
              terrenos, oficinas, edificios, locales comerciales, estaciones de
              servicios, entre otros.
            </p>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Inmuebles Rurales:
            </h2>
            <p>
              Terrenos, fincas, haciendas, establos, galpones, cercas, sistemas
              de riego, sistemas de drenaje, vías, adecuación de suelos, pozos,
              cultivos, plantaciones y explotaciones agrícolas.
            </p>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Inmuebles Especiales:
            </h2>
            <p>
              Centros comerciales, hoteles, colegios, clubes, clínicas, avance
              de obras, empresas de servicios públicos eléctricos y demás
              construcciones civiles y electromecánicas.
            </p>
          </div>
        {/if}
        <!-- This is the section for Muebles -->
        {#if currentService === "muebles"}
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Maquinaria Industrial:
            </h2>
            <p>
              Plantas de combustibles, maquinaria en general, equipos para
              explotación petrolera, subestaciones de planta, tableros
              eléctricos, equipos de generación, subestaciones de transmisión y
              distribución
            </p>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Equipo de Proceso:
            </h2>
            <p>
              Equipos e infraestructura, maquinaria de construcción, equipos de
              telecomunicaciones, movimiento de tierra, workover, maquinaria
              para producción y proceso.
            </p>
          </div>
        {/if}
        <!-- This is the section for Intangibles -->
        {#if currentService === "intangibles"}
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Empresas en marcha:
            </h2>
            <p>Acciones, títulos mineros e inmobiliarios, bonos etc.</p>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-left text-primary">
              Recursos Naturales y Ambientales:
            </h2>
            <p>
              Bienes ambientales, zonas de protección y reserva, minas,
              yacimientos y explotaciones.
            </p>
          </div>
        {/if}
      </div>
    </div>
    <div class="flex justify-center mt-4 md:mt-8">
      <a
        href="brochure-propiedad-raiz.pdf"
        target="_blank"
        class="btn btn-primary"
        ><HouseCheck fill="#B8E4FF"/> &nbsp; Propiedad Raiz</a
      >
    </div>
  </section>
  <section class="w-full p-4 md:py-8 md:px-12" id="certificaciones">
    <div class="max-w-sm md:max-w-6xl m-auto">
      <h2 class="text-3xl font-bold text-center text-primary">
        Certificaciones
      </h2>
      <p class="my-5 text-center">
        Contamos con certificaciones a nivel corporativo e individual. Nuestro
        equipo cuenta con certificados profesionales y técnicos, los cuales nos
        posicionan por encima de la competencia en la industria.
      </p>
    </div>
    <div
      class="flex justify-center flex-wrap gap-4  max-w-sm md:gap-12 md:max-w-6xl m-auto"
    >
      <img
        src="images/CertIngMecanico.svg"
        alt="certificado ingeniero mecanico"
        class="w-56 md:w-64"
      />
      <img
        src="images/registro-abierto-de-avaluador.svg"
        alt="certificado ingeniero mecanico"
        class="w-56 md:w-64"
      />
      <img
        src="images/tecnico-profesional-construccion.svg"
        alt="certificado ingeniero mecanico"
        class="w-56 md:w-64"
      />
      <img
        src="images/union-panamericana-valuadores.svg"
        alt="certificado ingeniero mecanico"
        class="w-56 md:w-64"
      />
      <img
        src="images/tecnico-laboral-avaluos.svg"
        alt="certificado ingeniero mecanico"
        class="w-56 md:w-64"
      />
    </div>
  </section>
  <section class="w-full bg-neutral p-4 md:py-8 md:px-12" id="preguntas">
    <div class="max-w-sm md:max-w-6xl m-auto">
      <h2 class="text-3xl font-bold text-center text-primary">
        Preguntas Frecuentes
      </h2>
      <div class="my-4 gap-4 md:my-8 md:gap-8">
        <div
          tabindex="0"
          class={`collapse collapse-arrow ${
            currentQuestion === "necesitar" ? "collapse-open" : "collapse-close"
          } border border-base-300 bg-base-100 rounded-box`}
        >
          <div
            on:click={() => handleSelectQuestion("necesitar")}
            class="collapse-title text-xl font-medium"
          >
            ¿Qué necesitamos para hacer un avalúo o valuación?
          </div>
          <div class="collapse-content">
            <div class="tabs font-semibold mx-4">
              <button
                class={`tab ${
                  currentService === "inmuebles"
                    ? "tab-active bg-neutral rounded-t-md"
                    : ""
                }`}
                on:click={() => handleSelectService("inmuebles")}
                >Inmuebles</button
              >
              <button
                class={`tab ${
                  currentService === "muebles"
                    ? "tab-active bg-neutral rounded-t-md"
                    : ""
                }`}
                on:click={() => handleSelectService("muebles")}>Muebles</button
              >
              <button
                class={`tab ${
                  currentService === "intangibles"
                    ? "tab-active bg-neutral rounded-t-md"
                    : ""
                }`}
                on:click={() => handleSelectService("intangibles")}
                >Intangibles</button
              >
            </div>
            <div
              class="grid p-4 flex-grow card bg-neutral rounded-md flex-wrap gap-4"
            >
              <!-- Needs for Valuation of Inmuebles -->
              {#if currentService === "inmuebles"}
                <ul class="list-disc px-4">
                  <li>Certificado de tradición.</li>
                  <li>Certificado Predial.</li>
                  <li>Normatividad del predio.</li>
                  <li>Reglamento de propiedad horizontal.</li>
                  <li>Escrituras.</li>
                  <li>
                    Planos arquitectónicos, hidrosanitarios y eléctricos para
                    consultas.
                  </li>
                  <li>Inspecciones del inmueble.</li>
                </ul>
              {/if}
              <!-- Needs for Valuation of Muebles -->
              {#if currentService === "muebles"}
                <ul class="list-disc px-4">
                  <li>
                    Inventario con las Bases de datos de los muebles a valuar
                    con fecha de compra y valor histórico.
                  </li>
                  <li>
                    Acceso a las facturas de compra para obtener el costo
                    histórico de los muebles y la fecha.
                  </li>
                  <li>
                    Manuales técnicos y comerciales de los activos muebles si se
                    hace necesario.
                  </li>
                  <li>Contratos de obra de los muebles.</li>
                  <li>
                    Visita a los bienes muebles con toma del registro
                    fotográfico respectivo.
                  </li>
                </ul>
              {/if}
              <!-- Needs for Valuation of Intangibles -->
              {#if currentService === "intangibles"}
                <ul class="list-disc px-4">
                  <li>
                    Estados Financieros de la empresa durante los últimos 5 años
                    pasados.
                  </li>
                  <li>Certificado de cámara de comercio.</li>
                  <li>RUT.</li>
                  <li>Marcas registradas de la firma.</li>
                  <li>Licencias del intangible a valorar.</li>
                  <li>Licencias mineras.</li>
                  <li>Planos y/o mapas.</li>
                  <li>Know how – saber hacer.</li>
                  <li>Estudios de factibilidad y capacidad.</li>
                  <li>Licencias ambientales. PMA.</li>
                  <li>Estudios de estimaciones de reservas probables.</li>
                  <li>
                    Certificaciones de calidad e idoneidad de los atributos de
                    la firmas. Información del mercado de la firma a valorar.
                  </li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
        <div
          tabindex="0"
          class={`collapse collapse-arrow ${
            currentQuestion === "entregable"
              ? "collapse-open"
              : "collapse-close"
          } border border-base-300 bg-base-100 rounded-box`}
        >
          <div
            on:click={() => handleSelectQuestion("entregable")}
            class="collapse-title text-xl font-medium"
          >
            ¿Cuál es el entregable después de una valuación?
          </div>
          <div class="collapse-content">
            <p>
              Un informe o reporte valuatorio donde vaya la estimación del valor
              del bien.
            </p>
          </div>
        </div>
        <div
          tabindex="0"
          class={`collapse collapse-arrow ${
            currentQuestion === "costo" ? "collapse-open" : "collapse-close"
          } border border-base-300 bg-base-100 rounded-box`}
        >
          <div
            on:click={() => handleSelectQuestion("costo")}
            class="collapse-title text-xl font-medium"
          >
            ¿Cuánto vale realizar una valuación?
          </div>
          <div class="collapse-content">
            <p>Contáctenos. El costo es con base en el bien(es) a valorar.</p>
          </div>
        </div>
        <div
          tabindex="0"
          class={`collapse collapse-arrow ${
            currentQuestion === "demora" ? "collapse-open" : "collapse-close"
          } border border-base-300 bg-base-100 rounded-box`}
        >
          <div
            on:click={() => handleSelectQuestion("demora")}
            class="collapse-title text-xl font-medium"
          >
            ¿Cuánto tiempo se demora una valuación?
          </div>
          <div class="collapse-content">
            <p>Depende de la misma.</p>
          </div>
        </div>
        <div
          tabindex="0"
          class={`collapse collapse-arrow ${
            currentQuestion === "alcances" ? "collapse-open" : "collapse-close"
          } border border-base-300 bg-base-100 rounded-box`}
        >
          <div
            on:click={() => handleSelectQuestion("alcances")}
            class="collapse-title text-xl font-medium"
          >
            ¿Qué alcances tiene una valuación?
          </div>
          <div class="collapse-content">
            <ul class="list-disc px-4">
              <li>Para apalancamientos financieros.</li>
              <li>Comercial o para vender o comprar un bien.</li>
              <li>Para asegurar.</li>
              <li>
                Para fines contables, NIIF Normas Internacionales de Información
                Financiera
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    class="w-full bg-primary font-base-100 p-4 md:py-8 md:px-12"
    id="contactenos"
  >
    <div
      class="max-w-sm flex-col justify-center md:flex-row md:max-w-6xl m-auto"
    >
      <h2 class="text-3xl mb-4 font-bold text-center text-base-100">
        Contáctenos
      </h2>
      <div
        class="flex flex-col p-4 items-center md:justify-evenly md:flex-row m-auto"
      >
        <form
          class="flex flex-col bg-base-100 rounded p-4 gap-2 w-64 md:p-8 md:w-5/12"
          on:submit|preventDefault={sendEmail}
        >
          <div>
            <h2 class="text-lg font-bold text-left text-primary">
              Envíenos un mensaje
            </h2>
            <div class="divider m-0" />
          </div>
          {#if isFormSuccessVisible}
            <div class="alert alert-success shadow-lg">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="stroke-current flex-shrink-0 h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  ><path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  /></svg
                >
                <span>Su mensaje ha sido enviado!</span>
              </div>
            </div>
          {/if}
          <div class="form-control w-full max-w-lg">
            <label class="label" for="name">
              <span class="label-text font-semibold">Nombre</span>
            </label>
            <input
              type="text"
              id="user_name"
              name="user_name"
              placeholder="Escriba aquí"
              class="input input-bordered w-full max-w-lg"
              required
            />
          </div>
          <div class="form-control w-full max-w-lg">
            <label class="label" for="email">
              <span class="label-text font-semibold">Correo</span>
            </label>
            <input
              type="email"
              id="user_email"
              name="user_email"
              placeholder="Escriba aquí"
              class="input input-bordered w-full max-w-lg"
              required
            />
          </div>
          <div class="form-control">
            <label class="label" for="message">
              <span class="label-text font-semibold">Mensaje</span>
            </label>
            <textarea
              id="message"
              name="message"
              class="textarea textarea-bordered h-24"
              placeholder="Escriba aquí"
              required
            />
          </div>
          <button class="btn btn-block btn-primary" type="submit">Enviar</button
          >
        </form>
        <div
          class="flex flex-col justify-center items-center rounded mt-4 gap-2 w-64 md:mt-0 md:items-start md:p-8 md:w-5/12"
        >
          <a class="btn btn-ghost border-none p-0" href="/"
            ><img class="h-full rounded" src="images/logo.png" alt="Logo" /></a
          >
          <div class="flex items-center flex-wrap md:text-lg">
            <h2 class="font-semibold text-left text-base-100 mr-2">Email:</h2>
            <a href="mailto:conmetodo250@gmail.com" class="text-base-100"
              >conmetodo250@gmail.com</a
            >
          </div>
          <div class="flex items-center flex-wrap md:text-lg">
            <h2 class="font-semibold text-left text-base-100 mr-2">
              Teléfono:
            </h2>
            <a href="https://wa.me/573114885081" class="text-base-100"
              >+57 (311) 488-5081</a
            >
          </div>
          <div class="flex items-center flex-wrap md:text-lg">
            <h2 class="font-semibold text-left text-base-100 mr-2">Sede A:</h2>
            <address class="text-base-100">
              Sede Bogotá Calle 131a No. 9a-16. Colombia.
            </address>
          </div>
          <div class="flex items-center flex-wrap md:text-lg">
            <h2 class="font-semibold text-left text-base-100 mr-2">Sede B:</h2>
            <address class="text-base-100">
              Sede Pereira Carrera 13 N. 23-35. Colombia.
            </address>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1084.0574151583303!2d-74.03376401954716!3d4.710834603477939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f855423b1ac0b%3A0xa8146d722a5c50ed!2sEdificio%20Bosque%20del%20Country!5e0!3m2!1sen!2sca!4v1663281430675!5m2!1sen!2sca"
            width="275"
            height="200"
            title="Sede Bogota"
            style="border:0;"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          />
          <p class="text-sm text-base-100 italic">
            Ubicación: Sede Bogotá, Colombia
          </p>
          <div class="flex gap-4">
            <a
              href="https://wa.me/573114885081"
              target="_blank"
              class="text-base-100"
            >
              <Whatsapp width="30" height="30" fill="#FDFCFD" /></a
            >
            <a
              href="https://instagram.com/conmetodovaluaciones?igshid=ZDdkNTZiNTM="
              target="_blank"
              class="text-base-100"
            >
              <Instagram width="30" height="30" fill="#FDFCFD" /></a
            >
            <a
              href="https://www.facebook.com/profile.php?id=100090782371251"
              target="_blank"
              class="text-base-100"
            >
              <Facebook width="30" height="30" fill="#FDFCFD" /></a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<footer class="footer footer-center p-10 bg-primary text-base-content">
  <div class="divider m-0" />
  <div>
    <p class="text-base-100">
      Copyright © 2022 - All right reserved by CONMETODO S.A.S.
    </p>
  </div>
</footer>
